var PaymentField;
(function (PaymentField) {
    PaymentField["BANK_CODE"] = "bankCode";
    PaymentField["BANK_BRANCH"] = "bankBranch";
    PaymentField["BANK_ACCOUNT"] = "bankAccount";
    PaymentField["BANK_ACCOUNT_TYPE"] = "bankAccountType";
    PaymentField["PIX_KEY_TYPE"] = "pixKeyType";
    PaymentField["EMAIL"] = "email";
})(PaymentField || (PaymentField = {}));
/**
 * Bank Account Type for the withdrawal transaction
 *
 * Note: API Spec from Pay4Fun denotes that these should be uppercase
 * however all samples and examples show these as lowercase strings.
 */
var BankAccountType;
(function (BankAccountType) {
    BankAccountType["PERSONAL"] = "personal";
    BankAccountType["SAVINGS"] = "saving";
})(BankAccountType || (BankAccountType = {}));
/**
 * Defines the 'PixKeyType' for each withdrawal method used.
 */
var WithdrawalPixKeyType;
(function (WithdrawalPixKeyType) {
    WithdrawalPixKeyType["CPF"] = "CPF";
    WithdrawalPixKeyType["EMAIL"] = "Email";
    WithdrawalPixKeyType["TELEPHONE"] = "Telefone";
    WithdrawalPixKeyType["BANK_DETAILS"] = "DadosBancarios";
})(WithdrawalPixKeyType || (WithdrawalPixKeyType = {}));

export { BankAccountType, PaymentField, WithdrawalPixKeyType };
